import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { getAttendenceData } from '../../services/dataService';
import toast from 'react-hot-toast';
import { getSecureItem } from '../../services/SecureStorage';

function Present() {
    const location = useLocation();
    const { TotalHeadcount } = location.state || {};
    const { selectedProfitCenter } = location.state || {};
    const isAdmin = getSecureItem("IsAdmin");


    useEffect(() => {
        console.log(selectedProfitCenter, 'jj');
    }, [selectedProfitCenter]);

    const UID = getSecureItem("userId");

    const [loading, setLoading] = useState(false);
    const [attendanceData, setAttendanceData] = useState([]);
    const [totalHeadCount, setTotalHeadCount] = useState([]);
    const [filteredAttendance, setFilteredAttendance] = useState([]);

    // Filter states
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [departments, setDepartments] = useState([]);
    const [selectedProfitCenterName, setSelectedProfitCenter] = useState('');
    const [profitCenters, setProfitCenters] = useState([]);

    useEffect(() => {
        setSelectedProfitCenter(selectedProfitCenter)
    }, [selectedProfitCenter]);

    const getAttendence = async () => {
        const payload = {
            Date: new Date().toISOString().split("T")[0],
            UserId: UID
        };

        try {
            setLoading(true);
            const response = await getAttendenceData(payload);
            console.log(response.data.data, 'attendance data');

            if (response?.data?.data) {
                setAttendanceData(response.data.data);
            } else {
                console.error("Invalid response structure:", response);
                toast.error("Failed to load attendance data - invalid data format");
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
            toast.error(error.response?.data?.message || "Failed to fetch attendance data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        console.log("Fetching attendance data...");
        getAttendence();
    }, []);

    useEffect(() => {
        if (TotalHeadcount && Array.isArray(TotalHeadcount)) {
            console.log(TotalHeadcount, "Total Headcount Data");
            const attendanceFromDashBoard = attendanceData.filter((el) =>
                TotalHeadcount.some((p) => p.ID === el.ID)
            );
            setTotalHeadCount(attendanceFromDashBoard);
            console.log(attendanceFromDashBoard, 'filtered attendance');
        }
    }, [TotalHeadcount, attendanceData]);

    // Extract unique departments and profit centers
    useEffect(() => {
        const uniqueDepartments = [...new Set(totalHeadCount.map(att => att.DepartmentName))];
        const uniqueProfitCenters = [...new Set(totalHeadCount.map(att => att.ProfitcenterName))];
        setDepartments(uniqueDepartments);
        setProfitCenters(uniqueProfitCenters);
    }, [totalHeadCount]);

    // Filter attendance based on search, department, and profit center
    useEffect(() => {
        let filtered = totalHeadCount;

        // Filter by search term (name, code, department, or profit center)
        if (searchTerm) {
            filtered = filtered.filter(att =>
                att.EmployeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                att.EmpCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                att.DepartmentName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                att.ProfitcenterName?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filter by department
        if (selectedDepartment) {
            filtered = filtered.filter(att => att.DepartmentName === selectedDepartment);
        }

        // Filter by profit center
        if (selectedProfitCenterName) {
            filtered = filtered.filter(att => att.ProfitcenterName === selectedProfitCenterName);
        }

        setFilteredAttendance(filtered);
    }, [totalHeadCount, searchTerm, selectedDepartment, selectedProfitCenterName]);

    // Format time to HH:MM
    const formatTime = (timeString) => {
        if (!timeString) return 'N/A';
        const time = new Date(timeString);
        return time.toISOString().substr(11, 5);
    };

    return (
        <div className="container mx-auto p-6 bg-white min-h-screen">
            {/* Header Section */}
            <div className="mb-6">
                <div className="flex items-center justify-between mb-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">
                            Today's Total Head Count {selectedProfitCenter ? `on ${selectedProfitCenter}` : ''}
                        </h1>
                        {isAdmin == 0 && filteredAttendance?.length > 0 && (
                            <>
                                {console.log(isAdmin, 'hshshs')}
                                <p className="text-2xl text-gray-800">
                                    Department: {[...new Set(filteredAttendance.map((el) => el.DepartmentName))].join(", ")}
                                </p>
                            </>
                        )}

                        <p className="text-gray-600 mt-1">
                            {new Date().toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            })}
                        </p>
                    </div>
                    <Link
                        to="/"
                        className="btn btn-success"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Back to Dashboard
                    </Link>
                </div>

                {/* Filter Section */}
                <div className="bg-gray-50 p-4 rounded-lg mb-4">
                    <div className="flex flex-col md:flex-row gap-4">
                        {/* Search Input */}
                        <div className="flex-1">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Search by Name, Code, Department, or Profit Center
                            </label>
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Enter employee name, code, department, or profit center..."
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>

                        {/* Department Filter */}
                        {isAdmin == 1 &&
                            <div className="md:w-64">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Filter by Department
                                </label>
                                <select
                                    value={selectedDepartment}
                                    onChange={(e) => setSelectedDepartment(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                >
                                    <option value="">All Departments</option>
                                    {departments.map((dept, index) => (
                                        <option key={index} value={dept}>
                                            {dept}
                                        </option>
                                    ))}
                                </select>
                            </div>}

                        {/* Profit Center Filter */}
                        {!selectedProfitCenter &&
                            <div className="md:w-64">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Filter by Profit Center
                                </label>
                                <select
                                    value={selectedProfitCenterName}
                                    onChange={(e) => setSelectedProfitCenter(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                >
                                    <option value="">All Profit Centers</option>
                                    {profitCenters.map((profitCenter, index) => (
                                        <option key={index} value={profitCenter}>
                                            {profitCenter}
                                        </option>
                                    ))}
                                </select>
                            </div>}
                    </div>
                </div>
            </div>

            {/* Loading State */}
            {loading && (
                <div className="flex justify-center items-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    <span className="ml-2 text-gray-600">Loading...</span>
                </div>
            )}

            {/* Table */}
            {!loading && (
                <div className="overflow-x-auto shadow-lg rounded-lg">
                    <table className="min-w-full bg-white border border-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Sl No
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Emp Code
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Employee Name
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Department
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Profit Center
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Shift Name
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Start Time
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    End Time
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Punch In
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">
                                    Punch Out
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {filteredAttendance.length > 0 ? (
                                filteredAttendance.map((attendance, index) => (
                                    <tr key={attendance.ID} className="hover:bg-gray-50 transition-colors duration-200">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {index + 1}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {attendance.EmpCode || 'N/A'}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {attendance.EmployeeName || 'N/A'}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {attendance.DepartmentName || 'N/A'}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {attendance.ProfitcenterName || 'N/A'}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {attendance.ShiftName || 'N/A'}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {formatTime(attendance.StartTime)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {formatTime(attendance.EndTime)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {attendance.PUNCHIN ? formatTime(attendance.PUNCHIN) : 'Not Punched'}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 border-b">
                                            {attendance.PUNCHOUT ? formatTime(attendance.PUNCHOUT) : 'Not Punched'}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="px-6 py-8 text-center text-gray-500">
                                        {searchTerm || selectedDepartment || selectedProfitCenterName ?
                                            'No attendance records found matching your search criteria.' :
                                            'No attendance records found for today.'
                                        }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Results Count */}
            {!loading && filteredAttendance.length > 0 && (
                <div className="mt-4 text-sm text-gray-600">
                    Showing {filteredAttendance.length} of {totalHeadCount.length} employees
                    {(searchTerm || selectedDepartment || selectedProfitCenterName) && ' (filtered)'}
                </div>
            )}
        </div>
    );
}

export default Present;